import type {} from "@lit/react";
import { Scroller as ScrollerElement, } from "@vaadin/scroller/vaadin-scroller.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ScrollerElement, };
export type ScrollerEventMap = Readonly<{}>;
const events = {} as ScrollerEventMap;
export type ScrollerProps = WebComponentProps<ScrollerElement, ScrollerEventMap>;
export const Scroller = createComponent({
    elementClass: ScrollerElement, events, react: React, tagName: "vaadin-scroller"
});
